import { IPercentageRange } from '../types'

export function displayStringForDiscountPercentageRange(
  range: IPercentageRange
): string {
  if (range.min === range.max) {
    return `${range.min}% OFF`
  }
  if (range.min === 0) {
    return `UP TO ${range.max}% OFF`
  }
  return `${range.min}% – ${range.max}% OFF`
}
